import icon from "images/icons/icon-trigger.svg?raw"
import parse from "html-react-parser"

export default function TriggerIcon({ title }) {
  return (
    <span className="svg-icon" title={title}>
      {parse(icon)}
    </span>
  )
}
